import { createContext, RefObject } from 'react';

export const appRefContext = createContext<RefObject<HTMLDivElement>>({ current: null });
